export default __webpack_public_path__ + "static/media/ic_voucher.9a324684.svg";